import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SearchContextType {
  selectedCityFilter: string | null
  setSelectedCityFilter: (city: string | null) => void
  searchTriggered: boolean
  setSearchTriggered: (triggered: boolean) => void
}

const SearchContext = createContext<SearchContextType | undefined>(undefined)

export const SearchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedCityFilter, setSelectedCityFilter] = useState<string | null>(
    null,
  )
  const [searchTriggered, setSearchTriggered] = useState<boolean>(false)

  return (
    <SearchContext.Provider
      value={{
        selectedCityFilter,
        setSelectedCityFilter,
        searchTriggered,
        setSearchTriggered,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export const useSearch = (): SearchContextType => {
  const context = useContext(SearchContext)
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider')
  }
  return context
}
